<div class="organization-modal modal-content" piqetAngularDraggable>
  <div class="modal-header header-modal">
    <span class="bootstrap-dialog-title">{{ modalLabel }} </span>
    <button type="button" class="closeModal pull-right" aria-label="Close" (click)="onClose()">
      <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
    </button>
  </div>

  <div class="modal-body body-modal">
    <form [formGroup]="cityAddEditForm">
      <div class="row">
        <div class="col-sm-12">
          <div class="form-group required">
            <label *ngIf="cityAddEditForm.get('country')?.value" class="sub-header-drpdown pb-2"
              >Country</label
            >
            <ng-select
              [clearable]="true"
              [clearOnBackspace]="false"
              #country
              [items]="countryList"
              [searchable]="false"
              bindLabel="name"
              formControlName="country"
              [searchFn]="commonInputSearch"
              placeholder="Country *"
              (change)="onChange($event?.id)"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    type="text"
                    class="form-control accordion-search search-input"
                    id="inputValidation"
                    placeholder="Search..."
                    (input)="country.filter($any($event.target).value)"
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
              </ng-template>
            </ng-select>
            <div
              *ngIf="
                (submitted || cityAddEditForm.controls['country']?.touched) &&
                (cityAddEditForm.controls['country']?.invalid ||
                  cityAddEditForm.controls['country'].value.name === 'Country')
              "
              class="input-error"
            >
              Country is required.
            </div>
          </div>
        </div>

        <div class="col-sm-12">
          <div class="form-group">
            <label *ngIf="cityAddEditForm.get('state')?.value" class="sub-header-drpdown pb-2"
              >State</label
            >
            <ng-select
              [clearable]="true"
              [clearOnBackspace]="false"
              #state
              [items]="stateList"
              [searchable]="false"
              bindLabel="name"
              formControlName="state"
              [searchFn]="commonInputSearch"
              placeholder="State"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    type="text"
                    class="form-control accordion-search search-input"
                    id="inputValidation"
                    placeholder="Search..."
                    (input)="state.filter($any($event.target).value)"
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
              </ng-template>
            </ng-select>
          </div>
        </div>

        <div class="col-sm-12">
          <div class="form-group required" aria-required="true">
            <div class="services-form">
              <input
                formControlName="cityName"
                type="text"
                maxlength="50"
                placeholder="City name"
              />
              <label>City name</label>
              <div
                *ngIf="
                  (submitted || cityAddEditForm.controls['cityName']?.touched) &&
                  (cityAddEditForm.controls['cityName']?.invalid ||
                    cityAddEditForm.controls['cityName'].value == '')
                "
                class="input-error"
              >
                City name is required.
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>

  <div class="modal-footer text-margin">
    <button type="button" class="btn btn-light cancel-btn modelBtn" (click)="onClose()">
      Cancel
    </button>
    <button type="button" class="modelBtn purpleBtnHoverEffect" (click)="onSave()">Save</button>
  </div>
</div>
